import React, { useEffect, useRef } from 'react';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import raf from 'rc-util/lib/raf';
import * as keys from 'keys';

const HandleTooltip = (props) => {
  const {
    value,
    children,
    visible,
    // tipFormatter = (val) => `${val} %`,
    tipFormatter = (val) => `${val}`,
    ...restProps
  } = props;

  const tooltipRef = useRef();
  const rafRef = useRef(null);

  const cancelKeepAlign = () => {
    if (rafRef.current) {
      raf.cancel(rafRef.current);
    }
  };

  const keepAlign = () => {
    rafRef.current = raf(() => {
      if (tooltipRef.current) {
        tooltipRef.current.forceAlign();
      }
    });
  };

  useEffect(() => {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [value, visible]);

  return (
    <Tooltip
      placement="top"
      overlay={tipFormatter(value)}
      overlayInnerStyle={{ minHeight: 'auto' }}
      ref={tooltipRef}
      visible={visible}
      {...restProps}
    >
      {children}
    </Tooltip>
  );
};

const ClarivorSlider = ({ indexValues, displayValues, onChange, defaultValueIndex }) => {
  if (indexValues.length !== displayValues.length) {
    console.error('indexValues and displayValues must have the same length');
    return {};
  }

  // map all keys to values
  const indexToValue = indexValues.reduce((acc, value, index) => {
    acc[value] = displayValues[index];
    return acc;
  }, {});

  const marks = {
    [indexValues[0]]: {
      style: { whiteSpace: 'nowrap', fontSize: '14px' },
      label: displayValues[0],
    },
    [indexValues[indexValues.length - 1]]: {
      style: { whiteSpace: 'nowrap', fontSize: '14px' },
      label: displayValues[displayValues.length - 1],
    },
  };

  const handleRender = (node, props) => (
    <HandleTooltip
      value={indexToValue[props.value]}
      visible={props.dragging}
      overlayInnerStyle={{ minHeight: 'auto', fontSize: '14px' }}
    >
      {node}
    </HandleTooltip>
  );


  const defaultValue = defaultValueIndex ? indexValues[defaultValueIndex] : indexValues[0];

  return <Slider
    onChange={onChange}
    min={indexValues[0]}
    max={indexValues[indexValues.length - 1]}
    defaultValue={defaultValue}
    marks={marks}
    handleRender={handleRender}
    styles={{
      rail: { backgroundColor: '#ccc', height: 4 },
      track: { backgroundColor: keys.Color.blue, height: 4 },
      handle: {
        borderColor: keys.Color.blue,
        backgroundColor: keys.Color.blue,
        height: 15,
        width: 15,
      }
    }}
    />
};

export default ClarivorSlider;
